import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Filters } from 'types/Search';
import { SearchFiltersUtil } from 'utils/search_filters_util';

import { useSelector } from '../redux/hooks';
import { setDefaultFilters } from '../redux/slices/filters';

const getTrailFilterString = (filters: Filters) => {
  const queryObject: any = SearchFiltersUtil.createAlgoliaQueryObject({
    insidePolygon: null,
    filters,
    mobileWidth: false,
    page: null,
    completedIds: [],
    verifiedIds: [],
    analyticsTags: [],
    attributesToRetrieve: [],
    attributesToHighlight: []
  });
  const filterStrings = [queryObject.filters];

  if (filters.alertIds && filters.alertIds.length > 0) {
    filterStrings.push(`(${filters.alertIds.map(id => `alert_ids:${id}`).join(' OR ')})`);
  }

  return filterStrings.filter(f => f.length > 0).join(' AND ');
};

const getAlertFilterString = (filters: Filters) => {
  const filterStrings = [];

  const alertTypeFilterString = SearchFiltersUtil.createAlgoliaMultFilterString(filters.alert_type, 'alert_type:', 'OR');
  if (alertTypeFilterString.length > 0) {
    filterStrings.push(`(${alertTypeFilterString})`);
  }

  if (filters.alertIds && filters.alertIds.length > 0) {
    filterStrings.push(`(${filters.alertIds.map(id => `objectID:alert-${id}`).join(' OR ')})`);
  }

  return filterStrings.filter(f => f.length > 0).join(' AND ');
};

const useFilters = (initialFilters: Filters) => {
  const [defaultFilters] = useState(initialFilters);
  const [filtersReady, setFiltersReady] = useState(false);
  const currentFilters = useSelector(state => state.filters.filters);
  const filters = filtersReady ? currentFilters : defaultFilters;
  const dispatch = useDispatch();

  useEffect(() => {
    // Don't mark filters as ready until the filters slice has been reset
    const prepareFilters = async () => {
      await dispatch(setDefaultFilters({ filters: defaultFilters }));
      setFiltersReady(true);
    };

    prepareFilters();
  }, [dispatch, defaultFilters]);

  return {
    filters,
    defaultTrailFilters: getTrailFilterString(defaultFilters),
    trailFilters: getTrailFilterString(filters),
    alertFilters: getAlertFilterString(filters)
  };
};

export { getTrailFilterString, getAlertFilterString };
export default useFilters;
